import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import icon from '../../assets/icon-light.svg';
import './NavBar.css';

export default function NavBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  function handleLogout() {
    logout();
    navigate('/login');
  }

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/">
          <img src={icon} className="navbar-brand-icon" alt="" width="28" height="28" />
          Series 65 Prep
        </Link>
      </div>

      <button
        className="navbar-toggle"
        aria-label="Toggle navigation"
        onClick={() => setMenuOpen((open) => !open)}
      >
        &#9776;
      </button>

      <div className={`navbar-links ${menuOpen ? 'navbar-links--open' : ''}`}>
        {user ? (
          <>
            <Link to="/" onClick={() => setMenuOpen(false)}>Dashboard</Link>
            <Link to="/study-guide" onClick={() => setMenuOpen(false)}>Study Guide</Link>
            <Link to="/quizzes" onClick={() => setMenuOpen(false)}>Quizzes</Link>
            <Link to="/flashcards" onClick={() => setMenuOpen(false)}>Flashcards</Link>
            <Link to="/exams" onClick={() => setMenuOpen(false)}>Practice Exam</Link>
            <Link to="/progress" onClick={() => setMenuOpen(false)}>Progress</Link>
            <Link to="/settings/ai" onClick={() => setMenuOpen(false)}>AI Settings</Link>
            <button className="navbar-logout" onClick={handleLogout}>Log out</button>
          </>
        ) : (
          <>
            <Link to="/login" onClick={() => setMenuOpen(false)}>Log in</Link>
            <Link to="/register" onClick={() => setMenuOpen(false)}>Sign up</Link>
          </>
        )}
      </div>
    </nav>
  );
}
